import templateUrl from './resourceViewRefsToolbar.html'

/**
 * Toolbar for the list of referenced resources in the Resource View page.
 *
 * @example
 * <tmr-resource-view-refs-toolbar
 *   count=""
 *   refs-title="REPORT.ASNS.TITLE"
 *   current-page=""
 *   page-size=""
 *   pager-id="someUniquePagerId"
 * ></tmr-resource-view-refs-toolbar>
 *
 * @type {ngComponent}
 * @prop {number} refs-count
 * @prop {string} refs-title Title translation key
 * @prop {object=} refs-title-values Optional substitutions for title translation
 * @prop {number} current-page
 * @prop {number} page-size
 * @prop {string=} pager-id An optional per-route identifier for the pager. Allows for multiple orderBys/pagers on the same route
 */
export const tmrResourceViewRefsToolbar = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceViewRefsToolbarController',
  bindings: {
    refsCount: '<',
    refsTitle: '@',
    refsTitleValues: '<?',
    currentPage: '<',
    pageSize: '<',
    pagerId: '@',
  },
}

/**
 * Controller of component {@link tmrResourceViewRefsToolbar}.
 *
 * @type {ngController}
 */
export class tmrResourceViewRefsToolbarController {
  static ngType = 'controller'

  constructor(TmrPaging) {
    'ngInject'
    Object.assign(this, { TmrPaging })
  }

  $onInit() {
    if (this.pagerId) {
      this.currentPage = this.currentPage[this.pagerId]
      this.pageSize = this.pageSize[this.pagerId]
    }
  }

  goToPage(page) {
    return this.TmrPaging.go(page, this.pagerId)
  }
}
